module.exports = __webpack_public_path__ + "f446d316a7425d799ad5f622f7c8e050.svg";